export * from "./filterHelpers";

export const getFullAddress = location => {
  return `${location.streetAddress}, ${location.suburb} ${location.postcode}, ${
    location.country
  }`;
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/helpers/index.js